<template>
  <div class="xitongxiaoxi">
  	<div class="xt-title">{{$t('all.xitongxiaoxi')}}</div>
	<div class="xt-list" ref="listContainer" @scroll="handleScroll">
		<div class="xt-list-item" v-for="(item,index) in list" :key="index">
			<div class="xt-list-item-title">
				<div class="xt-list-item-title-left">
					<img src="../../assets/image/xitongxiaoxi_18_1@2x.png" alt=""/>
					<span>{{$t('all.xitongxiaoxi')}}</span>
				</div>
				<span class="xt-list-item-title-span">{{item.createTime}}</span>
			</div>
			<div class="xt-list-item-content">{{item.content}}</div>
		</div>
		<kong v-if="isKong"/>
	</div>
  </div>
</template>

<script>
import kong from "../kong/kong.vue";
import { getAppSysMsgList } from "@/api/user";
export default {
  components: {
    kong
  },
  data() {
    return {
	  queryParams:{
	  	page:1,
	  	size:10,
	  },
	  list:[],
	  hasMore: true,
	  isLoading: false,
	  isKong:false,
    };
  },
  mounted() {
	this.getAppSysMsgList()
  },
  methods: {
	// 获取系统消息
	async getAppSysMsgList() {
	  // 3. 如果正在加载或没有更多数据，则直接返回
	  if (this.isLoading || !this.hasMore) {
		return;
	  }
	
	  try {
		// 4. 发起请求前，将加载状态设为 true
		this.isLoading = true;
	
		const response = await getAppSysMsgList(this.queryParams);
		const newList = response.rows || [];
	
		if (this.queryParams.page === 1) {
		  this.list = newList;
		} else {
		  this.list = [...this.list, ...newList];
		}
	
		const totalPages = Math.ceil((response.total || 0) / this.queryParams.size);
		this.hasMore = this.queryParams.page < totalPages;
	    if(response.total == 0){
			this.isKong = true
		}else{
			this.isKong = false
		}
	  } catch (error) {
		console.error("获取直播列表失败:", error);
	  } finally {
		// 5. 请求结束（无论成功或失败），将加载状态恢复为 false
		this.isLoading = false;
	  }
	},
	
	// 滚动事件处理函数
	handleScroll() {
	  // 同样增加 isLoading 判断，防止在请求期间触发
	  if (this.isLoading || !this.hasMore) {
		return;
	  }
	
	  const container = this.$refs.listContainer;
	  // 判断滚动条是否到达底部（或接近底部）
	  const isAtBottom = container.scrollTop + container.clientHeight >= container.scrollHeight - 50; // 50px的缓冲距离
	
	  if (isAtBottom) {
		console.log("滚动到底部，触发加载更多");
		this.queryParams.page++;
		this.getAppSysMsgList();
	  }
	},

  }
};
</script>
<style scoped lang="scss">
	@import "./xitongxiaoxi.css";
</style>


// WEBPACK FOOTER //
// xitongxiaoxi.vue?074629bd